export const ORG_ROUTES = {
  orgRoot: "/employee/org",
  platforms: "/employee/org/platforms",
  vendors: "/employee/org/vendors",
  organisations: "/employee/org/organisations",
  myOrganisation: "/employee/org/my-organisation",
} as const;
